import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.PropertyExchange}-enter {
		.${Layouts.PropertyExchange}-background {
			opacity: 0;
		}

		.${Layouts.PropertyExchange} {
			opacity: 0;
		}
	}

	&.${Layouts.PropertyExchange}-enter-active,
		&.${Layouts.PropertyExchange}-enter-done,
		&.${Layouts.PropertyExchange}-exit {
		.${Layouts.PropertyExchange}-background {
			opacity: 1;
		}

		.${Layouts.PropertyExchange} {
			opacity: 1;
		}
	}

	&.${Layouts.PropertyExchange}-exit-active {
		.${Layouts.PropertyExchange}-background {
			opacity: 0;
		}

		.${Layouts.PropertyExchange} {
			opacity: 0;
		}
	}
`;
